export const BASIC_FEATURES = [
  "QR window stickers with Stock # + VIN, printed in bulk or one at a time",
  "Branded vehicle landing pages synced from your live inventory",
  "CARFAX report on pre-owned + payment calculator links on every page",
  "\"Text me this vehicle\" and new-arrival leads delivered to your CRM as ADF XML",
  "Admin + manager logins, dealer public page, new-arrivals page",
];

export const SPECIALIST_MATCH_FEATURES = [
  "4-question DISC-style shopper assessment (Driver / Connector / Supporter / Analyst)",
  "Specialist profiles with communication-style sliders",
  "AI matching that pairs each shopper with the specialist who fits how they buy",
  "Manager CRM scores (follow-up + completed tasks) that steer who gets the lead",
  "Matched specialist and shopper style ride inside the ADF lead to your CRM",
];

export const ADDON_STATUS = {
  none: { label: "Not included", cls: "border-slate-700 bg-slate-900 text-slate-400" },
  requested: { label: "Requested", cls: "border-amber-700/50 bg-amber-950/40 text-amber-400" },
  active: { label: "Active", cls: "border-emerald-700/50 bg-emerald-950/40 text-emerald-400" },
};
